import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import supabase from '../supabase';
import Messages from '../components/Messages';

const bg = '#f0ebe3';
const red = '#6B1A1A';
const dark = '#4a1010';
const serif = 'Playfair Display, serif';
const body = 'Cormorant Garamond, serif';

function ClientDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [reports, setReports] = useState([]);
  const [showReport, setShowReport] = useState(false);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');
  const [report, setReport] = useState({
    week_of: '',
    impressions: '',
    clicks: '',
    spend: '',
    leads: '',
    cost_per_lead: '',
    what_we_did: '',
    whats_next: '',
    notes: '',
  });

  useEffect(() => {
    fetchClientData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchClientData = async () => {
    const { data: prof, error } = await supabase.from('profiles').select('*').eq('id', id).single();
    if (error) { setLoading(false); return; }
    setProfile(prof);
    const { data: reps } = await supabase.from('reports').select('*').eq('client_id', id).order('created_at', { ascending: false });
    setReports(reps || []);
    setLoading(false);
  };

  const handleSendReport = async () => {
    if (!report.week_of || !report.what_we_did) {
      setStatus('Please fill in at least the week and what we did.');
      return;
    }
    setStatus('Sending report...');
    const { error } = await supabase.from('reports').insert({
      client_id: id,
      week_of: report.week_of,
      impressions: parseInt(report.impressions) || 0,
      clicks: parseInt(report.clicks) || 0,
      spend: parseFloat(report.spend) || 0,
      leads: parseInt(report.leads) || 0,
      cost_per_lead: parseFloat(report.cost_per_lead) || 0,
      what_we_did: report.what_we_did,
      whats_next: report.whats_next,
      notes: report.notes,
    });
    if (error) {
      setStatus('Error: ' + error.message);
    } else {
      setStatus('Report sent successfully!');
      setShowReport(false);
      setReport({ week_of: '', impressions: '', clicks: '', spend: '', leads: '', cost_per_lead: '', what_we_did: '', whats_next: '', notes: '' });
      fetchClientData();
    }
  };

  const inputStyle = { backgroundColor: 'transparent', border: 'none', borderBottom: '0.5px solid #d4c9bc', padding: '10px 0', fontSize: '14px', fontFamily: body, color: '#2a1a1a', outline: 'none', width: '100%' };
  const textareaStyle = { backgroundColor: 'transparent', border: '0.5px solid #d4c9bc', padding: '12px', fontSize: '14px', fontFamily: body, color: '#2a1a1a', outline: 'none', width: '100%', resize: 'vertical', minHeight: '100px', boxSizing: 'border-box' };

  if (loading) return (
    <div style={{ backgroundColor: bg, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: body }}>
      <p>Loading...</p>
    </div>
  );

  if (!profile) return (
    <div style={{ backgroundColor: bg, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: body }}>
      <p>Client not found. <span style={{ color: red, cursor: 'pointer' }} onClick={() => navigate('/admin')}>Go back</span></p>
    </div>
  );

  return (
    <div style={{ backgroundColor: bg, minHeight: '100vh', fontFamily: body, color: '#2a1a1a' }}>
      <nav style={{ backgroundColor: bg, borderBottom: '0.5px solid #d4c9bc', padding: '20px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <p style={{ color: red, fontSize: '13px', letterSpacing: '4px', margin: 0, cursor: 'pointer' }} onClick={() => navigate('/admin')}>← BACK TO DASHBOARD</p>
        <p style={{ color: red, fontSize: '13px', letterSpacing: '4px', margin: 0 }}>HERMES PARTNER CAPITAL — ADMIN</p>
      </nav>

      <div style={{ padding: '40px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '40px' }}>
          <div>
            <p style={{ color: red, fontSize: '10px', letterSpacing: '3px', margin: '0 0 8px' }}>CLIENT</p>
            <h2 style={{ fontFamily: serif, fontSize: '36px', fontWeight: '700', color: dark, margin: '0 0 8px' }}>{profile.full_name}</h2>
            <p style={{ color: '#555', fontSize: '14px', margin: 0 }}>{profile.business_name} · {profile.email} · {profile.phone}</p>
          </div>
          <button onClick={() => setShowReport(!showReport)} style={{ backgroundColor: red, color: bg, padding: '12px 28px', fontSize: '11px', letterSpacing: '2px', border: 'none', cursor: 'pointer', fontFamily: body }}>
            + CREATE REPORT
          </button>
        </div>

        {status && <p style={{ color: status.includes('success') ? 'green' : red, fontSize: '13px', marginBottom: '20px' }}>{status}</p>}

        {showReport && (
          <div style={{ border: '1px solid #d4c9bc', padding: '40px', marginBottom: '40px' }}>
            <p style={{ color: red, fontSize: '10px', letterSpacing: '3px', margin: '0 0 24px' }}>WEEKLY REPORT — {profile.full_name}</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '24px' }}>
              <div>
                <p style={{ color: '#888', fontSize: '11px', letterSpacing: '2px', margin: '0 0 4px' }}>WEEK OF</p>
                <input type="date" value={report.week_of} onChange={(e) => setReport({...report, week_of: e.target.value})} style={inputStyle} />
              </div>
              <div>
                <p style={{ color: '#888', fontSize: '11px', letterSpacing: '2px', margin: '0 0 4px' }}>IMPRESSIONS</p>
                <input type="number" placeholder="0" value={report.impressions} onChange={(e) => setReport({...report, impressions: e.target.value})} style={inputStyle} />
              </div>
              <div>
                <p style={{ color: '#888', fontSize: '11px', letterSpacing: '2px', margin: '0 0 4px' }}>CLICKS</p>
                <input type="number" placeholder="0" value={report.clicks} onChange={(e) => setReport({...report, clicks: e.target.value})} style={inputStyle} />
              </div>
              <div>
                <p style={{ color: '#888', fontSize: '11px', letterSpacing: '2px', margin: '0 0 4px' }}>SPEND ($)</p>
                <input type="number" placeholder="0.00" value={report.spend} onChange={(e) => setReport({...report, spend: e.target.value})} style={inputStyle} />
              </div>
              <div>
                <p style={{ color: '#888', fontSize: '11px', letterSpacing: '2px', margin: '0 0 4px' }}>LEADS</p>
                <input type="number" placeholder="0" value={report.leads} onChange={(e) => setReport({...report, leads: e.target.value})} style={inputStyle} />
              </div>
              <div>
                <p style={{ color: '#888', fontSize: '11px', letterSpacing: '2px', margin: '0 0 4px' }}>COST PER LEAD ($)</p>
                <input type="number" placeholder="0.00" value={report.cost_per_lead} onChange={(e) => setReport({...report, cost_per_lead: e.target.value})} style={inputStyle} />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <div>
                <p style={{ color: '#888', fontSize: '11px', letterSpacing: '2px', margin: '0 0 8px' }}>WHAT WE DID THIS WEEK</p>
                <textarea placeholder="Describe the work done this week..." value={report.what_we_did} onChange={(e) => setReport({...report, what_we_did: e.target.value})} style={textareaStyle} />
              </div>
              <div>
                <p style={{ color: '#888', fontSize: '11px', letterSpacing: '2px', margin: '0 0 8px' }}>WHAT'S NEXT</p>
                <textarea placeholder="Plans for next week..." value={report.whats_next} onChange={(e) => setReport({...report, whats_next: e.target.value})} style={textareaStyle} />
              </div>
              <div>
                <p style={{ color: '#888', fontSize: '11px', letterSpacing: '2px', margin: '0 0 8px' }}>NOTES FOR CLIENT</p>
                <textarea placeholder="Any additional notes..." value={report.notes} onChange={(e) => setReport({...report, notes: e.target.value})} style={textareaStyle} />
              </div>
            </div>
            <button onClick={handleSendReport} style={{ backgroundColor: red, color: bg, padding: '14px 28px', fontSize: '11px', letterSpacing: '2px', border: 'none', cursor: 'pointer', fontFamily: body, marginTop: '24px' }}>
              SEND REPORT
            </button>
          </div>
        )}

        <div>
          <p style={{ color: red, fontSize: '10px', letterSpacing: '3px', margin: '0 0 16px' }}>PAST REPORTS</p>
          {reports.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', border: '1px solid #d4c9bc' }}>
              <p style={{ color: '#888', fontSize: '14px', fontStyle: 'italic' }}>No reports sent yet.</p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1px', backgroundColor: '#d4c9bc', border: '1px solid #d4c9bc' }}>
              {reports.map((rep, i) => (
                <div key={i} style={{ backgroundColor: bg, padding: '24px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                    <p style={{ fontFamily: serif, fontSize: '18px', fontWeight: '700', color: dark, margin: 0 }}>Week of {rep.week_of}</p>
                    <p style={{ color: '#888', fontSize: '12px', margin: 0 }}>{new Date(rep.created_at).toLocaleDateString()}</p>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                    <div><p style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', margin: '0 0 4px' }}>IMPRESSIONS</p><p style={{ fontFamily: serif, fontSize: '18px', fontWeight: '700', color: dark, margin: 0 }}>{rep.impressions}</p></div>
                    <div><p style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', margin: '0 0 4px' }}>CLICKS</p><p style={{ fontFamily: serif, fontSize: '18px', fontWeight: '700', color: dark, margin: 0 }}>{rep.clicks}</p></div>
                    <div><p style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', margin: '0 0 4px' }}>SPEND</p><p style={{ fontFamily: serif, fontSize: '18px', fontWeight: '700', color: dark, margin: 0 }}>${rep.spend}</p></div>
                    <div><p style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', margin: '0 0 4px' }}>LEADS</p><p style={{ fontFamily: serif, fontSize: '18px', fontWeight: '700', color: dark, margin: 0 }}>{rep.leads}</p></div>
                    <div><p style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', margin: '0 0 4px' }}>COST/LEAD</p><p style={{ fontFamily: serif, fontSize: '18px', fontWeight: '700', color: dark, margin: 0 }}>${rep.cost_per_lead}</p></div>
                  </div>
                  <div style={{ borderTop: '0.5px solid #d4c9bc', paddingTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div><p style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', margin: '0 0 4px' }}>WHAT WE DID</p><p style={{ fontSize: '14px', color: '#555', margin: 0, lineHeight: '1.8' }}>{rep.what_we_did}</p></div>
                    {rep.whats_next && <div><p style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', margin: '0 0 4px' }}>WHAT'S NEXT</p><p style={{ fontSize: '14px', color: '#555', margin: 0, lineHeight: '1.8' }}>{rep.whats_next}</p></div>}
                    {rep.notes && <div><p style={{ color: '#888', fontSize: '10px', letterSpacing: '2px', margin: '0 0 4px' }}>NOTES</p><p style={{ fontSize: '14px', color: '#555', margin: 0, lineHeight: '1.8' }}>{rep.notes}</p></div>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={{ marginTop: '40px' }}>
  <Messages
    currentUserId="admin"
    otherUserId={profile.email}
    currentUserRole="admin"
  />
</div>

      </div>
    </div>
  );
}

export default ClientDetail;